import { RentalPortalViewingProfileDocuments } from '../RentalPortalViewingProfileDocuments'
import { RentalPortalViewingProfileOverview } from '../RentalPortalViewingProfileOverview'
import { RentalPortalViewingProfileUpdates } from '../RentalPortalViewingProfileUpdates'

export const VIEWING_PROFILE_TAB_DOCUMENTS = 'documents'

export const VIEWING_PROFILE_TAB_OVERVIEW = 'overview'

export const VIEWING_PROFILE_TAB_UPDATES = 'updates'

export const QA_NAME_VIEWING_PROFILE_TAB_DOCUMENTS =
  'viewingProfileDocumentsTab'

export const QA_NAME_VIEWING_PROFILE_TAB_OVERVIEW = 'viewingProfileOverviewTab'

export const QA_NAME_VIEWING_PROFILE_TAB_UPDATES = 'viewingProfileUpdatesTab'

export const VIEWING_PROFILE_TAB_LIST = [
  {
    Content: RentalPortalViewingProfileOverview,
    id: VIEWING_PROFILE_TAB_OVERVIEW,
    qaName: QA_NAME_VIEWING_PROFILE_TAB_OVERVIEW,
    titleKey: 'RentalPortal.ListingProfileTabOverviewKey',
  },
  {
    Content: RentalPortalViewingProfileUpdates,
    id: VIEWING_PROFILE_TAB_UPDATES,
    permissionKey: 'can_view_updates',
    qaName: QA_NAME_VIEWING_PROFILE_TAB_UPDATES,
    titleKey: 'RentalPortal.ListingProfileTabUpdatesKey',
  },
  {
    Content: RentalPortalViewingProfileDocuments,
    id: VIEWING_PROFILE_TAB_DOCUMENTS,
    permissionKey: 'can_view',
    qaName: QA_NAME_VIEWING_PROFILE_TAB_DOCUMENTS,
    titleKey: 'RentalPortal.ListingProfileTabDocumentsKey',
  },
]
